import React from 'react';
import { FaLinkedinIn, FaGithub, FaDocker, FaInstagram, FaMedium } from 'react-icons/fa';

const SocialMedia = () => (
    <div className="app__social">
        <a href="https://www.linkedin.com/in/vinc" target="_blank" rel="noreferrer">
            <FaLinkedinIn />
        </a>
        <a href="https://github.com/VL-037" target="_blank" rel="noreferrer">
            <FaGithub />
        </a>
        <a href="https://vincentlow037.medium.com" target="_blank" rel="noreferrer">
            <FaMedium />
        </a>
        <a href="https://hub.docker.com/u/vl037" target="_blank" rel="noreferrer">
            <FaDocker />
        </a>
        <a href="https://www.instagram.com/_vincentluo" target="_blank" rel="noreferrer">
            <FaInstagram />
        </a>
    </div>
);

export default SocialMedia;